var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1"},React.createElement("path",{"id":"Combined-Shape","d":"M19,14.15C17.44,17.6,13.97,20,9.94,20C4.45,20,0,15.55,0,10.06C0,6.03,2.4,2.56,5.85,1\r\n\t\tC5.28,2.25,4.97,3.63,4.97,5.09c0,5.49,4.45,9.94,9.94,9.94C16.37,15.03,17.75,14.72,19,14.15z"})));
}

Moon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 20 20","enableBackground":"new 0 0 20 20","xmlSpace":"preserve"};

module.exports = Moon;

Moon.default = Moon;
